// Login.js
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import style from './Login.module.css';
import Botao from 'components/Botao';
import { AuthContext } from 'contexts/AuthContext';
import Carregando from 'components/Carregando';
import alertAppDownload from './alertAppDownload';
import Cookies from 'js-cookie';
import WallpaperMenu from 'components/WallpaperMenu';
import { auth } from 'lib/firebaseClient';
import { signInWithPopup, GoogleAuthProvider, OAuthProvider, signOut } from 'firebase/auth';

const GoogleIcon = () => (
    <svg className={style.googleIcon} viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M21.6 12.23c0-.79-.07-1.54-.2-2.27H12v4.3h5.38a4.6 4.6 0 0 1-2 3.02v2.5h3.24c1.9-1.75 2.98-4.32 2.98-7.55Z" />
        <path fill="#34A853" d="M12 22c2.7 0 4.96-.9 6.62-2.43l-3.24-2.5c-.9.6-2.04.96-3.38.96-2.6 0-4.8-1.76-5.59-4.12H3.07v2.58A10 10 0 0 0 12 22Z" />
        <path fill="#FBBC05" d="M6.41 13.91A5.99 5.99 0 0 1 6.41 10.1V7.52H3.07a10 10 0 0 0 0 12.78l3.34-2.59Z" />
        <path fill="#EA4335" d="M12 6.04c1.47 0 2.79.5 3.83 1.49l2.87-2.87A9.95 9.95 0 0 0 12 2a10 10 0 0 0-8.93 5.52l3.34 2.59C7.2 7.8 9.4 6.04 12 6.04Z" />
    </svg>
);

export default function Login() {

    const navigate = useNavigate();
    // const userData = {};
    const { userAcesso, setErrorMessage, setIsLoading, isLoading, errorMessage, possuiUnidade } = useContext(AuthContext);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

    useEffect(() => {
        setIsLoading(false);
    }, [setIsLoading]);

    useEffect(() => {
        alertAppDownload();
    }, []);

    useEffect(() => {
        const veioDoMenu = sessionStorage.getItem('veioDoMenu');
        if (userAcesso && !veioDoMenu) {
            navigate('/menu');
        }
        sessionStorage.removeItem('veioDoMenu');
    }, [userAcesso, navigate]);

    const handleLogin = async () => {
        setIsLoading(true);
        setErrorMessage(null);

        try {
            const provider = new OAuthProvider('microsoft.com');
            provider.addScope('openid');
            provider.addScope('email');
            provider.addScope('profile');
            // Mesmo tenant que o MSAL usava (authority com TENANT_ID); sem isso o Firebase usa o endpoint "common"
            if (process.env.REACT_APP_TENANT_ID) {
                provider.setCustomParameters({ tenant: process.env.REACT_APP_TENANT_ID });
            }
            await signInWithPopup(auth, provider);
        } catch (error) {
            if (error.code !== 'auth/popup-closed-by-user' && error.code !== 'auth/cancelled-popup-request') {
                setErrorMessage('Erro durante o login Microsoft: ' + error.message);
            }
            setIsLoading(false);
        }
    };

    const handleGoogleLogin = async () => {
        setIsLoading(true);
        setErrorMessage(null);

        try {
            const provider = new GoogleAuthProvider();
            provider.addScope('email');
            provider.addScope('profile');
            await signInWithPopup(auth, provider);
        } catch (error) {
            if (error.code !== 'auth/popup-closed-by-user' && error.code !== 'auth/cancelled-popup-request') {
                setErrorMessage('Erro durante o login Google: ' + error.message);
            }
            setIsLoading(false);
        }
    };

    const sair = async () => {
        Object.keys(Cookies.get()).forEach(cookieName => { Cookies.remove(cookieName); });
        localStorage.clear();
        await signOut(auth);
    }

    const entrar = () => {
        if (possuiUnidade) {
            navigate('/menu');
        } else {
            navigate('/sem-unidade');
        }
    }

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <WallpaperMenu />
            <main className={style.mainLogin}>
                <div className={style.campoLogin}>
                    <img className={style.logo} alt='Logo da Religião de Deus' src='./img/logo-rd.png' />
                    <div className={style.div}>
                        <h1 className={style.titulo}>Missionários da{!isDesktop ? <br /> : ' '}Religião de Deus
                        </h1>
                        <p className={style.p}>Seja bem-vindo ao aplicativo!</p>
                    </div>
                    {!userAcesso &&
                        <>
                            <Botao onClick={handleLogin} triggerEnter={true}>
                                Login Religião de Deus
                            </Botao>
                            <Botao onClick={handleGoogleLogin} background='google'>
                                <span className={style.buttonContent}>
                                    <GoogleIcon />
                                    <span>Entrar com Google</span>
                                </span>
                            </Botao>
                        </>
                    }
                    {isLoading && (
                        <Carregando tipo="circulo" />
                    )}
                    {/* Usa o userAcesso do contexto */}
                    {(userAcesso && !isLoading) && (
                        <>
                            <Botao onClick={entrar} triggerEnter={true}>
                                Entrar
                            </Botao>
                            <Botao onClick={sair} background='vermelho'>
                                Sair
                            </Botao>
                        </>
                    )}
                    {/* Mensagem de erro */}
                    {errorMessage && (
                        <div className={style.error}>
                            {errorMessage.split('\n').map((line, index) => (
                                <p key={index}>{line}</p>
                            ))}
                        </div>
                    )}
                </div>
            </main>
        </>
    );
}
